/**
*
*   Shopify Store
*       - Loads the Store Data
*
**/

//Address Field
const address = `
	address1
	address2
	city
	company
	country
	firstName
	formatted
	formattedArea
	id
	lastName
	name
	phoneNumber
	province
	territoryCode
	zoneCode
	zip
`;

const customer = `
	id
	creationDate
	displayName
	firstName
	lastName
	tags
	phoneNumber {
		phoneNumber
		marketingState
	}
	emailAddress {
		emailAddress
		marketingState
	}
	defaultAddress {
		${ address }
	}
	numberOfOrders: orders(first:200){
		edges {
			node {
				id
			}
		}
	}
	photo: metafield(
		namespace: "profile"
		key: "photo"
	){
		id,
		value
	}
	username: metafield(
		namespace: "profile"
		key: "username"
	){
		id,
		value
	}
	storeCreditAccounts(first:50) {
		edges {
			node {
				id
				balance {
					amount
					currencyCode
				}
			}
		}
	}
`;


//Customer Functions
const obj = {



	//Get the Customer
	get: {
		type: 'query',
		variables: null,
		request: `
			customer {
				${ customer }
			}
		`
	},



	//Get the Customer
	update: {
		type: 'mutation',
		name: 'customerUpdate',
		variables: '$input: CustomerUpdateInput!',
		request: `
			customerUpdate(customer: $input) {
				customerUserErrors {
					code
					field
					message
				}
				customer {
					${ customer }
				}
			}
		`
	},



	//Get the Customer
	addresses: {


		//Get the customer address list
		list: {
			type: 'query',
			variables: null,
			request: `
				customer {
					id
					addresses(first: 50){
						edges {
							node {
								${ address }
							}
						}
					}
				}
			`
		},


		//Delete a customer addresss
		delete: {
			type: 'mutation',
			name: 'customerAddressDelete',
			variables: '$id: ID!',
			request: `
				customerAddressDelete(addressId: $id) {
					userErrors {
						code
						field
						message
					}
					deletedAddressId
				}
			`
		},


		//Create a new address for the customer
		create: {
			type: 'mutation',
			name: 'customerAddressCreate',
			variables: '$address: CustomerAddressInput!, $default: Boolean',
			request: `
				customerAddressCreate(address: $address, defaultAddress: $default) {
					userErrors {
						code
						field
						message
					}
					customerAddress {
						${ address }
					}
				}
			`
		},


		//Update a Customer Address
		update: {
			type: 'mutation',
			name: 'customerAddressUpdate',
			variables: '$id: ID!, $address: CustomerAddressInput!, $default: Boolean',
			request: `
				customerAddressUpdate(addressId: $id, address: $address, defaultAddress: $default) {
					userErrors {
						code
						field
						message
					}
					customerAddress {
						${ address }
					}
				}
			`
		}

	},



	//Get the Customer
	order: {

		//Get an Order Details
		get: {
			type: 'query',
			variables: '$query: String!',
			request: `
				customer {
					orders(query:$query, first:1){
						edges {
							node {
								id
								name
								number
								processedAt
								cancelledAt
								financialStatus
								fulfillments(first:1, reverse:true){
									edges {
										node {
											status
										}
									}
								}
								totalPrice {
									amount
									currencyCode
								}
							}
						}
					}
				}
			`
		},

		//Get a Customer Order History
		history: {
			type: 'query',
			variables: null,
			request: `
				customer {
					orders(first:100){
						edges {
							node {
								id
								name
								number
								processedAt
								cancelledAt
								financialStatus
								fulfillments(first:1, reverse:true){
									edges {
										node {
											status
										}
									}
								}
								totalPrice {
									amount
									currencyCode
								}
							}
						}
					}
				}
			`
		}
	},

	/*

				addresses {
					address1
					address2
					city
					company
					country
					countryCodeV2
					firstName
					formatted {
						withName
						withCompany
					}
					formattedArea
					id
					lastName
					latitude
					longitude
					name
					phone
					province
					provinceCode
					zip
				}
	*/



	/**
	*
	*   format
	*       - Format the Collection List
	*
	*   Params:
	*       product     (Object) The Product Objects
	*
	**/
	format: (obj,customer) => {

		//Get the Total number of orders
		if( customer?.numberOfOrders )
			customer.numberOfOrders = customer.numberOfOrders.edges.length;

		if( customer?.phoneNumber )
			customer.phone = customer.phoneNumber.phoneNumber;

		if( customer?.emailAddress )
			customer.email = customer.emailAddress.emailAddress;

		//Remove edges & nodes from order
		if( customer?.orders )
			customer.orders = customer.orders.edges.map( order => ({
				...order.node,
				orderNumber: order.node.number,
				fulfillmentStatus: ( fulfillment => {
					return ( fulfillment.edges.length > 0 ?
						fulfillment.edges[0].node.status
						:
						order.node.cancelledAt ? 'Cancelled' : ''
					);
				})( order.node.fulfillments )
			}) );

		//Remove edges & nodes from addresses
		if( customer?.addresses )
			customer.addresses = customer.addresses.edges.map( address => ({
				...address.node,
				provinceCode: address.node.zoneCode,
				countryCodeV2: address.node.territoryCode
			}) );

		//Return the customer
		return customer;
	}
};



//Export
export default obj;